let platformReadyPromise: Promise<void> | null = null;

function ensureGapiPlatformLoaded(): Promise<void> {

  if (platformReadyPromise) {

    return platformReadyPromise;

  }

  platformReadyPromise = new Promise<void>((resolve) => {

    if (typeof window === 'undefined') {

      resolve();

      return;

    }

    if (window.gapi?.load) {

      resolve();

      return;

    }

    const existing = document.querySelector(
      'script[src^="https://apis.google.com/js/platform.js"]',
    ) as HTMLScriptElement | null;

    if (existing) {

      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => resolve(), { once: true });

      return;

    }

    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/platform.js';
    script.async = true;
    script.defer = true;
    // apis.google.com sends Access-Control-Allow-Origin: *, so this lets uncaught
    // errors report a real message/stack instead of the opaque "Script error.".
    script.crossOrigin = 'anonymous';
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);

  });

  return platformReadyPromise;

}

function ensureSurveyOptInLoaded(): Promise<void> {

  if (typeof window === 'undefined') {

    return Promise.resolve();

  }

  if (window.gapi?.surveyoptin) {

    return Promise.resolve();

  }

  return new Promise<void>((resolve) => {

    const loadSurveyOptIn = () => {

      try {

        if (!window.gapi?.load) {

          resolve();

          return;

        }

        window.gapi.load('surveyoptin', () => resolve());

      } catch {

        resolve();

      }

    };

    if (window.gapi?.load) {

      loadSurveyOptIn();

      return;

    }

    ensureGapiPlatformLoaded().then(loadSurveyOptIn).catch(() => resolve());

  });

}

export default defineNuxtPlugin((nuxtApp) => {

  const renderGCRSurvey = async (options: Record<string, unknown>): Promise<void> => {

    if (import.meta.server) {

      return;

    }

    const localeValue =
      (nuxtApp.$i18n as { locale?: { value?: string } })?.locale?.value ?? 'en';
    const lang = localeValue.split('-')[0] || 'en';

    // Must be set before (or at least during) platform.js load.
    window.___gcfg = { lang };

    await ensureSurveyOptInLoaded();

    try {

      window.gapi?.surveyoptin?.render?.(options);

    } catch {

      // Intentionally swallow: 3rd-party failures should not break checkout.

    }

  };

  nuxtApp.provide('renderGCRSurvey', renderGCRSurvey);

});